var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group", class: { feedback: _vm.validationMessage } },
    [
      !_vm.checkBoxType
        ? _c("label", [_vm._v(_vm._s(_vm.label) + ":")])
        : _vm._e(),
      _vm._v(" "),
      !_vm.checkBoxType
        ? _c("b-input", {
            ref: _vm.field,
            attrs: {
              type: _vm.type,
              name: _vm.field,
              required: "",
              placeholder: _vm.label
            },
            model: {
              value: _vm.value,
              callback: function($$v) {
                _vm.value = $$v
              },
              expression: "value"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.checkBoxType
        ? _c("checkBox", {
            ref: "chbx",
            attrs: { label: _vm.label, checked: _vm.value }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-down" } }, [
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.validationMessage,
                expression: "validationMessage"
              }
            ],
            staticClass: "alert alert-danger feedback-message"
          },
          [_vm._v("\n          " + _vm._s(_vm.getMsg(_vm.field)) + "\n    ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Users/FormField.vue?vue&type=template&id=8b7a0678&
// module id = null
// module chunks = 